// Capitalizes all words and replaces underscores with spaces
export function capitalizeWords(str: string): string {
  if (typeof str !== "string") {
    return str;
  }
  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/(?:^|\s|-)\S/g, (char) => char.toUpperCase()); // Capitalize first letter of each word and after dashes
}
